module.exports = __webpack_public_path__ + "img/logo.f1ffbd6c.png";